/*
 * Copyright Mimic Networks, Inc. 2024.
 */
import { Row as AntDRow, RowProps as AntDRowProps } from 'antd';

export type RowProps = {
  children: React.ReactNode;
  gutter?: AntDRowProps['gutter'];
  wrap?: AntDRowProps['wrap'];
  justify?: AntDRowProps['justify'];
  align?: AntDRowProps['align'];
  style?: React.CSSProperties;
};

export function Row({ children, gutter, wrap, justify, align, style }: RowProps) {
  const calculatedStyle = style || {};
  if (!calculatedStyle.width) {
    calculatedStyle.width = '100%';
  }
  return (
    <AntDRow gutter={gutter} wrap={wrap} justify={justify} align={align} style={calculatedStyle}>
      {children}
    </AntDRow>
  );
}
